module.exports = __webpack_public_path__ + "static/2017-aeta-outreach4-3979209ddc813487403dd191aaa7dbb1.jpg";